<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-btn text @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="5" offset-lg="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="justify-center font-weight-bold ui-module-titlebar" v-bind="cardTitleProps">
            Sugerencia de curso
          </v-card-title>
          <v-card-text class="pb-2">
            <v-container fluid class="pa-0">
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-avatar class="suggestion-avatar" size="80" color="secondary">
                    <v-icon size="48" color="primary">mdi-account</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="8" align="left" class="suggestion-personal-info">
                  <div class="white--text text-subtitle-1 font-weight-medium">{{ getFullName(personal) }}</div>
                  <div class="white--text text-caption text-secondary">{{ personal.CUIP }}</div>
                  <div class="white--text text-caption text-secondary">
                    {{ personal.CatPuestoDependencia.catPuesto.title }}
                  </div>
                  <div class="white--text text-caption text-secondary">Operativo</div>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="sugerencia.fk_idCurso"
                    class="ui-form-field mb-2"
                    filled
                    rounded
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    label="Curso sugerido"
                    :items="cursos"
                    item-value="id"
                    item-text="subcategoria"
                  ></v-select>
                  <v-text-field
                    v-model="sugerencia.otroCurso"
                    label="Nuevo curso sugerido"
                    class="ui-form-field"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="sugerencia.comentario"
                    no-resize
                    rows="4"
                    class="ui-form-textarea"
                    color="secondary"
                    background-color="transparent"
                    label="Comentario"
                    rounded
                    filled
                    dense
                    hide-details
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center ui-module-actions" v-bind="cardActionsProps">
            <v-btn class="ui-module-btn-text-danger" v-bind="secondaryButtonProps">Cancelar</v-btn>
            <v-btn
              class="ui-module-btn-solid"
              v-bind="primaryButtonProps"
              v-on:click="triggerSaveSugerenciaCurso()"
              :disabled="loading"
              :loading="loading"
              >Enviar sugerencia</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.suggestion-avatar {
  box-shadow: 0 10px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.24);
}

.suggestion-personal-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.text-secondary {
  color: rgba(224, 224, 224, 0.72) !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot,
::v-deep .ui-form-textarea .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover,
::v-deep .ui-form-textarea .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.38) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot,
::v-deep .ui-form-textarea.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.48) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-select__selection,
::v-deep .ui-form-textarea textarea {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .v-icon,
::v-deep .ui-form-textarea .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .v-icon,
::v-deep .ui-form-textarea.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}
</style>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import {
  cardActionsProps,
  cardProps,
  cardTitleProps,
  primaryButtonProps,
  secondaryButtonProps,
} from '../../components/props/props'

export default {
  props: {
    personal: {
      type: Object,
    },
  },

  async mounted() {
    await this.fetchCursos()
  },

  data() {
    return {
      cardTitleProps,
      cardProps,
      cardActionsProps,
      primaryButtonProps,
      secondaryButtonProps,

      loading: false,
      cursoElegido: null,

      sugerencia: {
        fk_idPersonal: 0,
        fk_idCurso: 0,
        otroCurso: '',
        comentario: '',
      },
    }
  },

  computed: {
    ...mapGetters('curso', {
      cursos: 'getCursos',
    }),
  },

  methods: {
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('sugerenciaCursos', ['saveSugerenciaCurso']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    triggerSaveSugerenciaCurso: async function () {
      this.loading = true
      this.sugerencia.fk_idPersonal = this.personal.idPersonal
      await this.saveSugerenciaCurso(this.sugerencia)
      this.loading = false
      this.SET_SNACKBAR_MESSAGE('Se ha enviado la sugerencia de curso.')
      this.$router.push('/desarrollo_profesional/personal')
    },
  },
}
</script>
